export const locationPrefix = "/#";
export const SpinnerServices = [
	{
		name: "RankerX Free Spinner",
		key: "BuiltInSpinner"	
	},
	{
		name: "The Best Spinner",
		key: "TheBestSpinner"	
	},
	{
		name: "SpinRewriter",
		key: "SpinRewriter"	
	},
	{
		name: "WordAI",
		key: "WordAI"	
	},
	{
		name: "ESpinner",
		key: "ESpinner"	
	},
	{
		name: "spinner.com.br",
		key: "SpinnerComBr"	
	},
	{
		name: "spinnerbr.com",
		key: "SpinnerBR"	
	},	
	{
		name: "Spinea",
		key: "Spinea"	
	}							
];

export const IndexingServices = [
	{
		name: "OneIndexer",
		text: "1Indexer (Recommended)",
		key: "oneIndexerApiKey",
		link: "https://1indexer.com"
	},
	{
		name: "IndexInject",
		text: "Index Inject",
		key: "indexInjectApiKey",
		link: "https://indexinject.com"
	},
	{
		name: "SpeedLink",
		text: "Speed Links",
		key: "speedLinkApiKey",
		link: "http://speed-links.net"
	},
	{
		name: "ExpressIndexer",
		text: "Express Indexer",
		key: "expressIndexerApiKey",
		link: "http://www.expressindexer.solutions"
	},	
	{
		name: "Web20Indexer",
		text: "Web 2.0 Indexer",
		key: "web20IndexerApiKey",
		link: "http://web20indexer.com"
	},
	{
		name: "EliteLinkIndexer",
		text: "Elite Link Indexer",
		key: "eliteLinkIndexerApiKey",
		link: "http://elitelinkindexer.com"
	},	
	{
		name: "FlexIndexerBR",
		text: "FlexIndexer",
		key: "flexIndexerBRApiKey",
		link: "https://flexindexer.com"
	},
	{
		name: "InstantLinkIndexer",
		text: "Instant Link Indexer",
		key: "instantLinkIndexerApiKey",
		link: "http://www.instantlinkindexer.com"
	},
	{
		name: "BackLinksIndexer",
		text: "Backlinks Indexer",
		key: "backLinksIndexerApiKey",
		link: "https://backlinksindexer.com"
	},
	{
		name: "Indexification",
		text: "Indexification",
		key: "indexificationApiKey",
		link: "http://www.indexification.com"
	},
	{
		name: "FastLinkIndexer",
		text: "Fast Link Indexer",
		key: "fastLinkIndexerApiKey",
		link: "http://fastlinkindexer.com"
	},
	{
		name: "LinkProcessor",
		text: "Link Processor",
		key: "linkProcessorApiKey",
		link: "http://linkprocessor.com"
	},
	{
		name: "LinkCentaur",
		text: "Link Centaur",
		key: "linkCentaurApiKey",
		link: "https://www.linkcentaur.com"
	},
	{
		name: "LIndexed",
		text: "Lindexed",
		key: "lIndexedApiKey",
		link: "http://www.lindexed.com"
	},
	{
		name: "OneHourIndexing",
		text: "OneHourIndexing",
		key: "oneHourIndexingApiKey",
		link: "http://onehourindexing.co"
	}	
];


export const Kingoftheworld = "1xaX2OAzQm+Y8YQsrQ0nFmO2KZyMgRDPnHwzZtV+smY=";